// extracted by mini-css-extract-plugin
module.exports = {"connectionOptions":"BigQueryConnectionTypeSelectorModal_connectionOptions__3q3CK","connectionOptionsItem":"BigQueryConnectionTypeSelectorModal_connectionOptionsItem__LpCeb"};